/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLocationPlus = createReactComponent("location-plus", "IconLocationPlus", [
  [
    "path",
    {
      d: "M12 18l-2 -4l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-3.361 9.308",
      key: "svg-0"
    }
  ],
  ["path", { d: "M16 19h6", key: "svg-1" }],
  ["path", { d: "M19 16v6", key: "svg-2" }]
]);

export { IconLocationPlus as default };
//# sourceMappingURL=IconLocationPlus.js.map
